import { matchPath } from "react-router-dom";
import { BRAND_NAME } from "@/lib/constants";

export const DEFAULT_TITLE = BRAND_NAME;

const STATIC_TITLES: { pattern: string; title: string }[] = [
  { pattern: "/contacts", title: "Контакты" },
  { pattern: "/delivery", title: "Доставка" },
  { pattern: "/about", title: "О компании" },
  { pattern: "/privacy", title: "Политика конфиденциальности" },
  { pattern: "/terms", title: "Условия использования" },
  { pattern: "/login", title: "Вход" },
  { pattern: "/register", title: "Регистрация" },
  { pattern: "/verify-email", title: "Подтверждение почты" },
  { pattern: "/catalog", title: "Каталог" },
  { pattern: "/catalog/*", title: "Каталог" },
  { pattern: "/product/:id", title: "Товар" },
  { pattern: "/search", title: "Поиск" },
  { pattern: "/reviews", title: "Отзывы" },
  { pattern: "/collection/:type", title: "Подборка" },
  { pattern: "/favorites", title: "Избранное" },
  { pattern: "/cart", title: "Корзина" },
  { pattern: "/account", title: "Личный кабинет" },
  { pattern: "/account/orders", title: "Мои заказы" },
  { pattern: "/account/documents", title: "Документы" },
  { pattern: "*", title: "Страница не найдена" },
];

export function getStaticTitle(pathname: string): string {
  const match = STATIC_TITLES.find(({ pattern }) =>
    matchPath({ path: pattern, end: true }, pathname),
  );
  return match?.title ?? DEFAULT_TITLE;
}
